
import { useState, useEffect } from 'react'
import Form from "/src/components/form/Form";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import InputRange from '/src/components/UI/InputRange/InputRange';
import TextArea from '/src/components/UI/TextField/TextArea'
import TodoList from '/src/components/UI/TodoList/TodoList';
import ButtonAction from "/src/components/UI/Button/Button";
import { useForm, useFieldArray } from "react-hook-form";
import migrationService from '/src/features/plugins/migrations/services/migrationService';
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import {adaptTextAreaSize} from "/src/utils/adaptTextAreaSize";
import "./MigrationModalBody.css"
import CheckBox from '/src/components/UI/CheckBox/CheckBox';
import { env } from '../../../../../var/env'
function MigrationModalBody({ form }) {

    const data = form.data
    const { register, setError, clearErrors, handleSubmit, control, formState: { errors }, formState, getValues, setValue } = useForm({
        mode: "onChange",
        defaultValues: {
            name: data.name,
            create_new_bot: data.create_new_bot ? true : false,
            secret_token: data.secret_token,
            server: !isEmpty(data) && data.config.server ? data.config.server : env.REACT_APP_API_PATH,
            datasets: {
                ignore : !isEmpty(data) && data.config.datasets && data.config.datasets.ignore ? data.config.datasets.ignore.join(', ') : '',
                empty : !isEmpty(data) && data.config.datasets && data.config.datasets.empty ? data.config.datasets.empty.join(', ') : '',
                replace : !isEmpty(data) && data.config.datasets && data.config.datasets.replace ? Object.keys(data.config.datasets.replace).map(value => `${data.config.datasets.replace[value].join(',')}=${value}`).join('\n') : ''
            }
        },
    });

    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    const { addMigration, updateMigration } = migrationService;

    const onSubmit = async () => {

        let values = getValues();
        const {server, datasets, name, secret_token, create_new_bot} = values;
        let dataToSend = {create_new_bot, name, secret_token, config : {server, datasets}};

        if(dataToSend.config.datasets.ignore) {
            dataToSend.config.datasets.ignore = dataToSend.config.datasets.ignore.split(',').map(a => a.trim())
        } else delete dataToSend.config.datasets.ignore

        if(dataToSend.config.datasets.empty) {
            dataToSend.config.datasets.empty = dataToSend.config.datasets.empty.split(',').map(a => a.trim())
        } else delete dataToSend.config.datasets.empty

        let goodReplace = true;
        if(dataToSend.config.datasets.replace) {
            let tempData = dataToSend.config.datasets.replace.split('\n').map(a => a.split('=')).filter(a => a.length == 2);
            if(tempData.length == 0) goodReplace = false
            else {
                let object = {}
                tempData.map(item => object[item[1]] = item[0].split(',').map(a => a.trim()));
                dataToSend.config.datasets.replace = object
            }
        } 
        
        if(!dataToSend.config.datasets.replace || !goodReplace) {
            delete dataToSend.config.datasets.replace
        }

        if(Object.keys(dataToSend.config.datasets).length == 0) {
            delete dataToSend.config.datasets;
        }

        dataToSend.create_new_bot = dataToSend.create_new_bot ? 1 : 0;
        
        if (data.id != undefined) {     // mean we are in update form since we have data
            let [response, error] = await updateMigration(data.id, dataToSend)

            if (error !== null) {
                console.log(error);
                return;
            }
            modal.resolve(response)
            onClose({});
            return;
        }


        let [response, error] = await addMigration(dataToSend)
        if (error !== null) {
            console.log(error);
            return;
        }

        modal.resolve(response)
        onClose({});
        return;
        
        
    };

    useEffect(() => {
         let node = document.getElementById("area-datasets-replace")
         node.style.height = node.scrollHeight - 20 + "px";
    },[])

    function isEmpty(data){
        return Object.keys(data).length === 0
    }


    return (
        <div>
            <Form className="edit-container" onSubmit={handleSubmit(onSubmit)}>
                <Form.Title>{form.title}</Form.Title>
                <Form.Body className="body-editModal-container migration_container">
                    <div className="modal-bar">
                        <div>
                            <div style={{ display: 'flex'}}>
                                <Field label="Create new bot if already exist" />
                                <CheckBox checked={getValues("create_new_bot")} {...register('create_new_bot')} onChange={() => setValue('create_new_bot', !getValues('create_new_bot'))} />
                            </div>
                            <div>
                                <Field label="Name" />
                                <TextInput {...register('name', { required: true, minLength: 3 })} style={errors.name ? { borderColor: "red" } : {}}  placeholder="Choose your name" />
                            </div>
                            <div style={{ marginTop: "15px" }}>
                                <Field label="Server" />
                                <TextInput {...register('server', { required: true, minLength: 3 })} style={errors.server ? { borderColor: "red" } : {}} placeholder="Enter your server" />
                            </div>
                            <div style={{ marginTop: "15px" }}>
                                <Field label="Token" />
                                <TextInput {...register('secret_token', { required: true, minLength: 3 })} style={errors.secret_token ? { borderColor: "red" } : {}} placeholder="Enter your bot token" />
                            </div>
                        </div>

                    </div>
                    <div className="statement-container">
                            <div style={{ marginTop: "15px" }}>
                                <Field label="Dataset ignored" />
                                <TextInput {...register('datasets.ignore', { required: false, minLength: 1 })} style={errors.datasets && errors.datasets.ignore ? { borderColor: "red" } : {}} placeholder="faq1, faq2 ect..." />
                            </div>
                            <div style={{ marginTop: "15px" }}>
                                <Field label="Dataset imported but empty" />
                                <TextInput {...register('datasets.empty', { required: false, minLength: 1 })} style={errors.datasets && errors.datasets.empty ? { borderColor: "red" } : {}} placeholder="faq1, faq2 ect..." />
                            </div>
                            <div style={{ marginTop: "15px" }}>
                                <Field label="Words replace in dataset" />
                                <TextArea id="area-datasets-replace" onInput={(e)=> adaptTextAreaSize(e)} {...register('datasets.replace', { required: false, minLength: 1 })} style={errors.datasets && errors.datasets.replace  ? { borderColor: "red" } : {}} placeholder={"babar,toto=elephant\nbanana,orange=other"} />
                            </div>
                    </div>


                </Form.Body>
                <Form.Buttons>
                    <ButtonAction type="submit" label={data.id ? "Update" : "Add"} disabled={!formState.isValid} onSubmit={form.onSubmit}></ButtonAction>
                </Form.Buttons>
            </Form>
        </div >

    );
}
// <TextArea id="area_migration" onInput={(e)=> adaptTextAreaSize(e)} {...register('config', { required: true, minLength: 1, validate : value=>isJsonValid(value) })} style={errors.config ? { borderColor: "red" } : {}} placeholder="Configure your migration" />
export default MigrationModalBody;